import React from 'react';

class DockerContainers extends React.Component {
  render() {
    let { serverInfo } = this.props.hostInfo;
    let containers = serverInfo.containers || [];

    if (containers.length === 0) {
      return null;
    }

    let blocks = containers.map((cont) => {
      let installedApps = [];
      cont.serverInfo = cont.serverInfo || {};
      cont.serverInfo.app = cont.serverInfo.app || {};
      for (let name in cont.serverInfo.app) {
        let app = cont.serverInfo.app[name];
        if (app.version) {
          app.name = name;
          installedApps.push(app);
        }
      }
      return (
        <div className='pure-u-12-24' style={{ padding: '10px' }} key={cont.name}>
          <div className='docker-title'>{cont.name}</div>
          <div style={{ height: '100%', padding: '10px 0', fontSize: 14 }}>
            {installedApps.map((app) => {
              return (
                <div className='pure-g pure-u-1' key={app.name}>
                  <div className='pure-u-4-24' style={{ fontWeight: 500 }}>
                    {app.name}
                  </div>
                  <div className='pure-u-8-24' style={{ fontWeight: 400 }}>
                    {app.version}
                  </div>
                  <div className='pure-u-12-24'>{app.status}</div>
                </div>
              );
            })}
          </div>
        </div>
      );
    });

    // console.log(blocks);
    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 20, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>docker containers</div>
        </div>

        {blocks}
      </div>
    );
  }
}

export default DockerContainers;



// WEBPACK FOOTER //
// ./src/components/DockerContainers.js